import { configs } from "@/configs";
import { useAuth } from "@/provider/UserProvider";
import { getCollectionById } from "@/services/collection";
import { useEffect, useState } from "react";
import { queryConfigMintNFT, queryUserMintInfo } from "./helpers";

const isProduction = process.env.NEXT_PUBLIC_NODE_ENV === 'production';
export const EVENT_COLLECTION_ID = isProduction ? 375 : 193;

type Collection = {
  id: number,
  cover: string | null,
  banner: string | null,
  name: string,
  description: string,
  picture: string,
  numberOfItems: number,
  miniCover: string,
  provider: {
    id: number,
    publicAddress: string,
    username: string,
    picture?: string,
  }
}

const useFetch = () => {
  const [loading, setLoading] = useState(false);
  const [userTotalMint, setUserTotalMint] = useState('0');
  const [totalMinted, setTotalMinted] = useState('0');
  const [data, setData] = useState<Collection | null>(null);
  const { auth, isLoginClient } = useAuth();

  const handleFetchUserOnChange = async () => {
    const res = await queryUserMintInfo({ 
      contract: configs.launchpadContractAddress, 
      collection: EVENT_COLLECTION_ID,
      user: auth.user.publicAddress,
    });
    if (res.data) setUserTotalMint(res.data);
  }

  const handleFetchInfoCollection = async () => {
    const res = await queryConfigMintNFT({
      contract: configs.launchpadContractAddress,
      collection: EVENT_COLLECTION_ID,
    });
    if (res.data?.total_already_mint) {
      setTotalMinted(res.data.total_already_mint)
    }
  }

  const handleFetch = async (isRefresh = false) => {
    try {
      if (!isRefresh) setLoading(true);
      const res = await getCollectionById(EVENT_COLLECTION_ID);
      if (res.data) {
        setData({
          id: res.data.id,
          cover: res.data.cover,
          banner: res.data.banner,
          name: res.data.name,
          description: res.data.description,
          picture: res.data.picture,
          numberOfItems: res.data.numberOfItems,
          miniCover: res.data.miniCover,
          provider: {
            id: res.data.provider.id,
            publicAddress: res.data.provider.publicAddress,
            username: res.data.provider.username,
            picture: res.data.provider.picture,
          }
        });
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    handleFetch();
    handleFetchInfoCollection();
  }, []);

  useEffect(() => {
    if (isLoginClient) handleFetchUserOnChange();
  }, [isLoginClient]);

  const refresh = () => {
    handleFetchInfoCollection();
    if (isLoginClient) handleFetchUserOnChange();
  };

  return {
    loading,
    data,
    refresh,
    userTotalMint,
    totalMinted
  }
}

export default useFetch;